// extracted by mini-css-extract-plugin
export default {"sorteio":"Sorteio_sorteio__I7k8B","sorteio__resultado":"Sorteio_sorteio__resultado__N2kA6","botao_sortear":"Sorteio_botao_sortear__bpoIe"};